"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

interface DropdownProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  buttonRef: React.RefObject<HTMLButtonElement>;
  positionPreference?: "auto" | "top" | "bottom" | "left" | "right";
}

const Dropdown: React.FC<DropdownProps> = ({
  isOpen,
  onClose,
  children,
  buttonRef,
  positionPreference = "auto",
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
 

  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const dropdownWidth = dropdownRef.current?.offsetWidth || 200; 
      const dropdownHeight = dropdownRef.current?.offsetHeight || 150;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      let top = rect.bottom + 5; 
      let left = rect.left;
      let preferred = positionPreference;

      if (preferred === "auto") {
        if (rect.bottom + dropdownHeight > viewportHeight && rect.top > dropdownHeight) {
          preferred = "top";
        } else if (rect.right + dropdownWidth > viewportWidth) {
          preferred = "left";
        } else if (rect.left < dropdownWidth) {
          preferred = "right";
        } else {
          preferred = "bottom";
        }
      }

      switch (preferred) {
        case "top":
          top = rect.top - dropdownHeight - 5;
          break;
        case "left":
          left = rect.left - dropdownWidth - 5;
          break;
        case "right":
          left = rect.right + 5;
          break;
        case "bottom":
        default:
          top = rect.bottom + 5;
          break;
      }

      setPosition({ top: top + window.scrollY, left });
    }
  }, [isOpen, buttonRef, positionPreference]);

  const handleClickOutside = (e: MouseEvent) => {
      if (document.querySelector(".sub-compomente")) {
        return;
      }
 

      
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target as Node) &&
      buttonRef.current &&
      !buttonRef.current.contains(e.target as Node) 
    ) {
      onClose();
    }
  };

  useEffect(() => { 

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose, buttonRef]);


  



  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      ref={dropdownRef}
      className={`absolute bg-white border rounded-lg shadow-lg ease-in-out ${
        !isOpen ? "animate-fadeOut" : "animate-fadeIn"
      }`}
      style={{ top: position.top, left: position.left }}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>,
    document.body
  );
};
export default Dropdown;
